/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationResponse, UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteResetGroupPermissions";

function getUsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsUrl(groupId: UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsPathParams["groupId"]) {
  const res = { method: 'POST', url: `/admin/group/${groupId}/permissions/reset` as const }  
  return res
}

/**
 * @summary Reset all permissions for a group
 * {@link /admin/group/:groupId/permissions/reset}
 */
export async function usersAuthzAPIAdminPermissionsWriteResetGroupPermissions(groupId: UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsPathParams["groupId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getUsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsUrl(groupId).url.toString(), ... requestConfig })  
  return res.data
}